let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cjJTJ")).then(() => parcelRequire('iV9t7'));